import React from 'react';
import { NSCodePromo } from 'aqlrc';
import { formatPrice } from '../lib/utils';
import { withI18next } from '../lib/withI18n';

class CodePromo extends NSCodePromo {
    render() {
        const { code, promo } = this.state;
        const { t }           = this.props;

        return (
            <div className="form__controls form__controls--promo">
                <label htmlFor="field-promo" className="hidden">Search</label>

                <input name="field-code" id="field-promo" className="field" type="text" value={code} placeholder={t('cart:placeholder.discountCode')} onChange={this.handleChange} />

                <button type="button" onClick={promo ? this.remove : this.handleClick}>{promo ? 'ANNULER' : 'OK'}</button>
                { promo && <div style={{ magin: '50px 0 30px 0', fontSize: '14px' }} className="promo__controls">{promo.name} : {promo.description}</div> }
                { promo && promo.discountATI && (
                    <div
                        style={{
                            magin : '20px 0 50px 0', fontSize : '14px', height : '22px', color : '#576fa1',
                        }} className="promo__controls"
                    ><span style={{ float: 'right', fontWeight: 'bold' }}>{`- ${formatPrice(promo.discountATI)}`}</span></div>
                ) }
            </div>/* <!-- /.form__controls --> */
        );
    }
}

export default withI18next([])(CodePromo);
